import React, { useState, useEffect } from "react";
import "../../styles/admins/inventory.css";
import axios from "axios";

function AddTechnicians(props) {
  //   const today = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    id: props.editUser.id || '',
    techi_name: props.editUser.name || "",
    techi_id: props.editUser.staff_id || "",
    comp_id: props.editUser.company_id || "",
    contact: props.editUser.contact || "",
    email: props.editUser.email || "",
    pass: props.editUser.pass || "",
    designation: props.editUser.designation || "",
     image: props.editUser.image || null,
  });

  const [companies, setCompanies] = useState([]);

  // Fetch companies
  useEffect(() => {
    const getCompanies = async () => {
      try {
        const response = await axios.get(
          "https://api.dectwinservices.com/api/companies"
        );
         const filteredData = response.data.filter(
      (item) => item.is_active !== 1
    );
        setCompanies(filteredData);
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getCompanies();
  }, [props]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

    const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  // // Submit form data
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     if (Object.keys(props.editUser).length === 0) {
  //       await axios.post(
  //         "https://api.dectwinservices.com/api/add-techies",
  //         formData
  //       );
  //       props.handleToast({
  //         toastMsg: "Technician Added Successfully!!!",
  //         toastColor: "#4CAF50",
  //       });
  //     } else {
  //       await axios.put(
  //         "https://api.dectwinservices.com/api/update-techies",
  //         formData
  //       );
  //       props.handleToast({
  //         toastMsg: "Technician Updated Successfully!!!",
  //         toastColor: "#4CAF50",
  //       });
  //     }
  //     localStorage.removeItem("techies");
  //     window.location.reload();
  //   } catch (error) {
  //     props.handleToast({
  //       toastMsg: "Something went wrong! Please check data or internet.",
  //       toastColor: "#FF0000",
  //     });
  //   }
  // };


  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const formDataToSend = new FormData();

    Object.keys(formData).forEach((key) => {
      if (key === "image") {
        if (formData.image instanceof File) {
          formDataToSend.append("image", formData.image);
        }
      } else {
        formDataToSend.append(key, formData[key] ?? "");
      }
    });

    if (Object.keys(props.editUser).length === 0) {
      await axios.post(
        "https://api.dectwinservices.com/api/add-techies",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      props.handleToast({
        toastMsg: "Technician Added Successfully!!!",
        toastColor: "#4CAF50",
      });
    } else {
      await axios.put(
        "https://api.dectwinservices.com/api/update-techies",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      props.handleToast({
        toastMsg: "Technician Updated Successfully!!!",
        toastColor: "#4CAF50",
      });
    }

    localStorage.removeItem("techies");
    window.location.reload();
  } catch (error) {
    console.error(error);

    props.handleToast({
      toastMsg:
        error?.response?.data?.message ||
        "Something went wrong! Please check data or internet.",
      toastColor: "#FF0000",
    });
  }
};

  return (
    <section className="px-32">
      <div className="d-md-flex justify-between my-3">
        <div className="d-flex">
          <i className="bx bxs-plus-circle" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big">
            {Object.keys(props.editUser).length === 0
              ? "Add New Engineer"
              : `Edit Engineer "${props.editUser.name}"`}
          </p>
        </div>
        <button className="add-btn" onClick={props.toggler}>
          <i
            className="bx bxs-left-arrow-circle"
            style={{ fontSize: "22px" }}
          ></i>
          &nbsp; Back to Users
        </button>
      </div>

     <div className="p-3 bg-white" >

           {props.editUser.image &&
<div style={{textAlign: 'center'}}>
<img src={`https://api.dectwinservices.com/uploads/${props.editUser.image}`} style={{height: '6em', borderRadius: '50%', marginTop: '1em',
  border: '3px solid var(--gray)'
}} alt="user" /></div> }
        

        <form className="row" onSubmit={handleSubmit}>
          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="techi_name">Engineer Name</label>
            <div className="input-icon">
              <i className="bx bxs-layer"></i>
              <input
                type="text"
                name="techi_name"
                id="techi_name"
                value={formData.techi_name}
                onChange={handleChange}
                placeholder="Engineer Name"
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="techi_id">Engineer ID</label>
            <div className="input-icon">
              <i className="bx bx-id-card"></i>
              <input
                type="text"
                name="techi_id"
                id="techi_id"
                value={formData.techi_id}
                onChange={handleChange}
                placeholder="Engineer ID"
                required
                // disabled={!!props.editUser.name}
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="pass">Create Password</label>
            <div className="input-icon">
              <i className="bx bxs-lock"></i>
              <input
                type="text"
                name="pass"
                id="pass"
                value={formData.pass}
                onChange={handleChange}
                placeholder="Create Password"
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="comp_id">Select Company</label>
            <div className="input-icon">
              <i className="bx bxs-user"></i>
              <select
                name="comp_id"
                id="comp_id"
                value={formData.comp_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Company</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.id}>
                    {company.company_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="contact">Engineer Contact</label>
            <div className="input-icon">
              <i className="bx bx-phone"></i>
              <input
                type="text"
                name="contact"
                id="contact"
                placeholder="Staff Contact"
                value={formData.contact}
                onChange={handleChange}
                pattern="[0-9]*"
  maxLength={10}
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="email">Engineer Email</label>
            <div className="input-icon">
              <i className="bx bx-envelope"></i>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Engineer Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="designation">Engineer Role</label>
            <div className="input-icon">
              <i className="bx bx-briefcase"></i>
              <input
                type="text"
                name="designation"
                id="designation"
                placeholder="Engineer Role"
                value={formData.designation}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        
             <div className="form-data col-lg-4 col-md-6 col-12">
              <label htmlFor="image">Upload Image</label>
              <div className="input-icon"   style={{width:'18em'}}>
                <i className="bx bxs-image"></i>
                <input
                  type="file"
                  name="image"
                  id="image"
                  onChange={handleFileChange}
                  accept="image/*"
                
                />
              </div>
            </div>

         
          <div className="btn-group d-flex mt-2" style={{ justifyContent: "end" }}>


          <button type="submit" className="button-85">
            Submit
          </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default AddTechnicians;
